import { useEffect, useState } from "react";
import { Plus, X, Save } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, useApi } from "../lib/api";
import { PageHead, Card, Input, Btn, Loading } from "../components/kit";

const GROUPS = [
  ["cup_types", "Jenis Cup", "Contoh: Cup Bubble Tea"],
  ["cup_sizes", "Ukuran Cup", "Contoh: 700 ml"],
  ["print_sides", "Posisi / Sisi Cetak", "Contoh: Kiri-kanan"],
  ["payment_methods", "Metode Pembayaran", "Contoh: Mandiri, QRIS"],
];

function OptionGroup({ k, label, placeholder, list, onChange }) {
  const [v, setV] = useState("");
  const add = () => {
    const t = v.trim();
    if (!t) return;
    if (list.some((x) => x.toLowerCase() === t.toLowerCase())) return toast.error("Pilihan sudah ada");
    onChange([...list, t]);
    setV("");
  };
  return (
    <Card className="space-y-3" data-testid={`opt-group-${k}`}>
      <h3 className="font-bold text-lg">{label} <span className="text-slate-400 font-normal text-sm">({list.length})</span></h3>
      <div className="flex flex-wrap gap-2">
        {list.map((o) => (
          <span key={o} className="inline-flex items-center gap-1 pl-3 pr-1 h-10 rounded-full bg-slate-100 text-slate-800 text-sm font-semibold" data-testid={`opt-${k}-${o}`}>
            {o}<button type="button" onClick={() => onChange(list.filter((x) => x !== o))} className="w-8 h-8 grid place-items-center rounded-full hover:bg-rose-100 hover:text-rose-600" aria-label={`Hapus ${o}`} data-testid={`opt-remove-${k}-${o}`}><X className="w-4 h-4" /></button>
          </span>
        ))}
        {list.length === 0 && <span className="text-sm text-slate-400">Belum ada pilihan.</span>}
      </div>
      <div className="flex gap-2">
        <Input value={v} placeholder={placeholder} onChange={(e) => setV(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())} data-testid={`opt-input-${k}`} />
        <Btn type="button" variant="dark" onClick={add} data-testid={`opt-add-${k}`}><Plus className="w-5 h-5" /> Tambah</Btn>
      </div>
    </Card>
  );
}

export default function Settings() {
  const { data, mutate } = useApi("/settings/options", 0);
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (data && !f) setF(data); }, [data, f]);
  if (!f) return <Loading />;
  const dirty = JSON.stringify(f) !== JSON.stringify(data);
  const save = async () => {
    setBusy(true);
    try { const { data: d } = await api.put("/settings/options", f); mutate(d, false); setF(d); toast.success("Pilihan disimpan"); }
    catch (x) { toast.error(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <>
      <PageHead title="Pengaturan" sub="Kelola pilihan jenis cup, ukuran, sisi cetak, dan metode pembayaran" />
      {GROUPS.map(([k, label, ph]) => <OptionGroup key={k} k={k} label={label} placeholder={ph} list={f[k]} onChange={(list) => setF({ ...f, [k]: list })} />)}
      <div className="h-6" />
      <div className="sticky bottom-20 lg:bottom-4 z-20 pt-2">
        <Btn className="w-full h-14 text-lg shadow-lg" loading={busy} disabled={!dirty} onClick={save} data-testid="settings-save-btn"><Save className="w-5 h-5" /> Simpan Perubahan</Btn>
      </div>
    </>
  );
}
